import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/bankid.svg'


const _withScopeId = n => (_pushScopeId("data-v-00ef5f2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-info text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "alert alert-info text-center"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Logga in och verifiera mig som ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("xxxx ")
const _hoisted_5 = {
  key: 2,
  class: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Logga in och verifiera mig som:", -1))
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "form-check-label" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("xxxx ")
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "form-check-label" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("xxxx ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"display":"block","width":"80px","margin":"0 auto"},
    src: _imports_0
  })
], -1))
const _hoisted_14 = {
  key: 3,
  class: "row py-4"
}
const _hoisted_15 = { class: "col-sm-6 d-grid" }
const _hoisted_16 = { class: "col-sm-6 d-grid" }
const _hoisted_17 = {
  key: 0,
  style: {"margin":"0 auto"}
}
const _hoisted_18 = { class: "border-light border-top pt-3 mt-3" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6 offset-md-3 text-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary my-2",
  type: "submit"
}, " Start ", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { style: {"width":"60%","margin":"20px auto"} }
const _hoisted_26 = ["src"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Gick inte att logga in", -1))
const _hoisted_30 = { key: 3 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Gick inte att logga in", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" BankID-programmet verkar inte finnas på din dator eller telefon. Installera det och hämta ett BankID hos din internetbank. Installera programmet från "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://install.bankid.com" }, "install.bankid.com"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Laddar... "))
      : _createCommentVNode("", true),
    (_ctx.applicants.applicantId && !_ctx.applicants.coApplicantId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _hoisted_3,
            _createElementVNode("strong", null, _toDisplayString(_ctx.applicants.applicantPersonalNumberDate), 1),
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.applicants.applicantId && _ctx.applicants.coApplicantId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signAsCoApplicant = false)),
            class: "form-check"
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: !_ctx.signAsCoApplicant,
              class: "form-check-input"
            }, null, 8, _hoisted_7),
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.applicants.applicantPersonalNumberDate), 1),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signAsCoApplicant = true)),
            class: "form-check"
          }, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: _ctx.signAsCoApplicant,
              class: "form-check-input"
            }, null, 8, _hoisted_10),
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.applicants.coApplicantPersonalNumberDate), 1),
              _hoisted_12
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-lg btn-light mb-3", { selected: _ctx.chosenDevice == 'mobile' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.chosenDevice = 'mobile'))
            }, " Mobilt BankID ", 2)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-lg btn-light mb-3", { selected: _ctx.chosenDevice == 'other' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.chosenDevice = 'other'))
            }, " BankID på fil eller kort ", 2)
          ]),
          (_ctx.chosenDevice)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("form", {
                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args)), ["prevent"]))
                      }, _hoisted_22, 32)
                    ])
                  ])
                ])
              ], 512)), [
                [_vShow, _ctx.status == 'init']
              ])
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.status == 'pending' || _ctx.status == 'start')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            (_ctx.status == 'start')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Startar upp..."))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, _toDisplayString(_ctx.userMessage), 1),
            _createElementVNode("div", _hoisted_25, [
              (_ctx.qrCodeSrc)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    style: {"width":"100%"},
                    src: _ctx.qrCodeSrc
                  }, null, 8, _hoisted_26))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, " Avbryt inloggning ")
          ]))
        : _createCommentVNode("", true),
      (_ctx.status == 'complete')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Du loggas nu in"))
        : _createCommentVNode("", true),
      (_ctx.status === 'failed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", null, _toDisplayString(_ctx.userMessage), 1),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
            }, "Försök igen")
          ]))
        : _createCommentVNode("", true),
      (_ctx.status === 'error')
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _hoisted_31,
            _hoisted_32,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
              }, "Försök igen")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}